






































import moment from 'moment'
import _ from 'lodash'
import Vue from 'vue'
import Component from 'vue-class-component'
import { State, Mutation, Action } from 'vuex-class';
import DepartmentType from '@/modules/reservation/model/DepartmenType'
import {MutationTypes} from '@/modules/reservation/store/mutations'
import DepartmentTypeDetail from '@/modules/reservation/components/DepartmentTypeDetail.vue'
import Loader from '@/components/Loader.vue';
import ConfirmDepartmentTypeDelete from '@/modules/reservation/components/ConfirmDepartmentTypeDelete.vue';

/**
 * Lista de tipos de departamentos
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component({
    components: {ConfirmDepartmentTypeDelete, Loader, DepartmentTypeDetail},
})
export default class DepartmentTypeList extends Vue {

    @State(state => state.reservation.departmentTypes)
    public types: DepartmentType[]

    @State(state => state.reservation.currentDepartmentType)
    public departmentType: DepartmentType

    @Mutation('reservation/SET_CURRENT_DEPARTMENT_TYPE')
    public setCurrentDepartmentType: (departmentType: DepartmentType) => void

    @Mutation(`reservation/${MutationTypes.ToggleDepartmentTypeDetail}`)
    public toggleDetail: (show: boolean) => void

    @Action('reservation/loadDepartmentTypeList')
    public loadTypeList: () => void

    public creating = false
    public loading = true
    public deleteTypeDialog = false

    public select (type: DepartmentType) {
        this.setCurrentDepartmentType(_.cloneDeep(type))
        this.toggleDetail(true)
    }

    @Action('reservation/saveDepartmentType')
    public saveDepartmentType: () => void

    public headers = [
        { text: 'Id', value: 'id'},
        { text: 'Nombre', value: 'name'},
        { text: 'Hora de apertura', value: 'openingTime'},
        { text: 'Hora de cierre', value: 'closingTime'},
        { text: 'Duración de la reserva', value: 'duration'},
        { text: 'Acciones', value: 'id', sortable: false},
    ]

    /**
     * Formatea el tiempo de duración de las reservas
     */
    public fancyDurationTime (duration: number) {
        return moment().startOf('day').add(duration, 'seconds').format('HH:mm') + ' Horas'
    }

    /**
     * Método ejecutado cuando el usuario pulsa el botón de crear nuevo tipo
     * de registro
     */
    public addType () {
        this.setCurrentDepartmentType(new DepartmentType())
        this.toggleDetail(true)
    }

    /**
     * Muestra el dialogo de confirmación para eliminar el tipo de departamento
     * seleccionado
     *
     * @param type
     */
    public deleteType (type: DepartmentType) {
        this.setCurrentDepartmentType(type)
        this.deleteTypeDialog = true
    }

    public async save () {
        await this.saveDepartmentType()
        this.creating = false
    }

    public async created () {
        await this.loadTypeList()
        this.loading = false
    }
}
